import React from 'react';
import { FaInstagram, FaTiktok } from 'react-icons/fa';
import Newsletter from '../component/Newsletter';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { UserContactSubmission } from '../redux/user/contact_us/contact_services_sync';
// import { toast } from 'react-toastify';
import WhatsappButton from '../component/WhatsappButton';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone_number: '',
    message: '',
    acceptTerms: false,
  });

  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.acceptTerms) {
      // toast.error('Please accept terms and conditions');
      return;
    }
    dispatch(UserContactSubmission(formData)).then(() => {
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone_number: '',
        message: '',
        acceptTerms: false,
      });
    });
  };

  return (
    <main className="main__content_wrapper">
      <section className="breadcrumb__section breadcrumb__bg">
        <div className="container">
          <div className="row row-cols-1">
            <div className="col">
              <div className="breadcrumb__content">
                <h1 className="breadcrumb__content--title text-white mb-10">
                  Contact Us
                </h1>
                <ul className="breadcrumb__content--menu d-flex">
                  <li className="breadcrumb__content--menu__items">
                    <a className="text-white" href="/">
                      Home
                    </a>
                  </li>
                  <li className="breadcrumb__content--menu__items">
                    <span className="text-white">Contact Us</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact__section section--padding">
        <div className="container">
          <div className="section__heading mb-40">
            <h2 className="section__heading--maintitle contact__section--hrading mb-10">
              Get In Touch
            </h2>
            <p className="contact__section--hrading__desc">
              Let's connect and make your experience better. Get in touch with
              us today for personalized support, expert advice, and answers to
              all your queries.
            </p>
          </div>
          <div className="main__contact--area">
            <div className="row align-items-center row-md-reverse">
              <div className="col-lg-5">
                <div className="contact__info border-radius-10">
                  <div className="contact__info--items">
                    <h3 className="contact__info--content__title text-white mb-15">
                      Contact Us
                    </h3>
                    <div className="contact__info--items__inner d-flex">
                      <div className="contact__info--icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="31.568"
                          height="31.128"
                          viewBox="0 0 31.568 31.128"
                        >
                          <path
                            id="ic_phone_forwarded_24px"
                            d="M26.676,16.564l7.892-7.782L26.676,1V5.669H20.362v6.226h6.314Zm3.157,7a18.162,18.162,0,0,1-5.635-.887,1.627,1.627,0,0,0-1.61.374l-3.472,3.424a23.585,23.585,0,0,1-10.4-10.257l3.472-3.44a1.48,1.48,0,0,0,.395-1.556,17.457,17.457,0,0,1-.9-5.556A1.572,1.572,0,0,0,10.1,4.113H4.578A1.572,1.572,0,0,0,3,5.669,26.645,26.645,0,0,0,29.832,32.128a1.572,1.572,0,0,0,1.578-1.556V25.124A1.572,1.572,0,0,0,29.832,23.568Z"
                            transform="translate(-3 -1)"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <div className="contact__info--content">
                        <p className="text-white">
                          Feel free to contact us here
                          <br />
                          <p className="text-white mb-0">
                            +234 903 729 5388 whatsapp
                          </p>
                          <p className="mb-4 text-white">+234 803 060 3005</p>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="contact__info--items">
                    <h3 className="contact__info--content__title text-white mb-15">
                      Email Address
                    </h3>
                    <div className="contact__info--items__inner d-flex">
                      <div className="contact__info--icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="31.57"
                          height="31.13"
                          viewBox="0 0 31.57 31.13"
                        >
                          <path
                            id="ic_email_24px"
                            d="M30.413,4H5.157C3.421,4,2.016,5.751,2.016,7.891L2,31.239c0,2.14,1.421,3.891,3.157,3.891H30.413c1.736,0,3.157-1.751,3.157-3.891V7.891C33.57,5.751,32.149,4,30.413,4Zm0,7.783L17.785,21.511,5.157,11.783V7.891l12.628,9.728L30.413,7.891Z"
                            transform="translate(-2 -4)"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <div className="contact__info--content">
                        <p className="contact__info--content__desc text-white">
                          admin@gloriousevidence.com
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="contact__info--items">
                    <h3 className="contact__info--content__title text-white mb-15">
                      Office Location
                    </h3>
                    <div className="contact__info--items__inner d-flex">
                      <div className="contact__info--icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="31.57"
                          height="31.13"
                          viewBox="0 0 31.57 31.13"
                        >
                          <path
                            id="ic_account_balance_24px"
                            d="M5.323,14.341V24.718h4.985V14.341Zm9.969,0V24.718h4.985V14.341ZM2,32.13H33.57V27.683H2ZM25.262,14.341V24.718h4.985V14.341ZM17.785,1,2,8.412v2.965H33.57V8.412Z"
                            transform="translate(-2 -1)"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <div className="contact__info--content">
                        <p className="contact__info--content__desc text-white">
                          48 Bode Thomas Street, Surulere, Lagos, Nigeria.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="contact__info--items">
                    <h3 className="contact__info--content__title text-white mb-15">
                      Follow Us
                    </h3>
                    <ul className="contact__info--social d-flex">
                      <li className="contact__info--social__list">
                        <a
                          className="contact__info--social__icon"
                          target="_blank"
                          rel="noreferrer"
                          href="https://web.facebook.com/profile.php?id=61556289781723"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="7.667"
                            height="16.524"
                            viewBox="0 0 7.667 16.524"
                          >
                            <path
                              data-name="Path 237"
                              d="M967.495,353.678h-2.3v8.253h-3.437v-8.253H960.13V350.77h1.624v-1.888a4.087,4.087,0,0,1,.264-1.492,2.9,2.9,0,0,1,1.039-1.379,3.626,3.626,0,0,1,2.153-.6l2.549.019v2.833h-1.851a.732.732,0,0,0-.472.151.8.8,0,0,0-.246.642v1.719H967.8Z"
                              transform="translate(-960.13 -345.407)"
                              fill="currentColor"
                            ></path>
                          </svg>
                          <span className="visually-hidden">Facebook</span>
                        </a>
                      </li>
                      <li className="contact__info--social__list">
                        <a
                          className="contact__info--social__icon"
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.instagram.com/gloriousevidenceofficial"
                        >
                          <FaInstagram />
                          <span className="visually-hidden">Instagram</span>
                        </a>
                      </li>
                      <li className="contact__info--social__list">
                        <a
                          className="contact__info--social__icon"
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.tiktok.com/@gloriousevidenceofficial?_t=ZN-8ujr7nVT0vW&_r=1"
                        >
                          <FaTiktok />
                          <span className="visually-hidden">Tiktok</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="contact__form">
                  <form
                    className="contact__form--inner"
                    onSubmit={handleSubmit}
                  >
                    <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <div className="contact__form--list mb-20">
                          <label
                            className="contact__form--label"
                            htmlFor="input1"
                          >
                            First Name
                            <span className="contact__form--label__star">
                              *
                            </span>
                          </label>
                          <input
                            className="contact__form--input"
                            name="firstName"
                            id="input1"
                            placeholder="Your First Name"
                            type="text"
                            value={formData.firstName}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="contact__form--list mb-20">
                          <label
                            className="contact__form--label"
                            htmlFor="input2"
                          >
                            Last Name
                            <span className="contact__form--label__star">
                              *
                            </span>
                          </label>
                          <input
                            className="contact__form--input"
                            name="lastName"
                            id="input2"
                            placeholder="Your Last Name"
                            type="text"
                            value={formData.lastName}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="contact__form--list mb-20">
                          <label
                            className="contact__form--label"
                            htmlFor="input3"
                          >
                            Phone Number
                            <span className="contact__form--label__star">
                              *
                            </span>
                          </label>
                          <input
                            className="contact__form--input"
                            name="phone_number"
                            id="input3"
                            placeholder="Phone number"
                            type="text"
                            value={formData.phone_number}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="contact__form--list mb-20">
                          <label
                            className="contact__form--label"
                            htmlFor="input4"
                          >
                            Email
                            <span className="contact__form--label__star">
                              *
                            </span>
                          </label>
                          <input
                            className="contact__form--input"
                            name="email"
                            id="input4"
                            placeholder="Email"
                            type="email"
                            required
                            value={formData.email}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="contact__form--list mb-10">
                          <label
                            className="contact__form--label"
                            htmlFor="input5"
                          >
                            Write Your Message
                            <span className="contact__form--label__star">
                              *
                            </span>
                          </label>
                          <textarea
                            className="contact__form--textarea"
                            name="message"
                            id="input5"
                            placeholder="Write Your Message"
                            value={formData.message}
                            onChange={handleInputChange}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="account__login--remember position__relative mb-15">
                      <input
                        className="checkout__checkbox--input"
                        id="check2"
                        type="checkbox"
                        name="acceptTerms"
                        checked={formData.acceptTerms}
                        onChange={handleInputChange}
                      />
                      <span className="checkout__checkbox--checkmark"></span>
                      <label
                        className="checkout__checkbox--label login__remember--label"
                        htmlFor="check2"
                      >
                        Accept Terms & Condition
                      </label>
                    </div>
                    <button
                      className="contact__form--btn primary__btn"
                      type="submit"
                    >
                      Submit Now
                    </button>
                    <p className="form-messege"></p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="contact__map--area section--padding pt-0">
        <iframe
          title="Company Location - Glorious Evidence Limited"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15862.011748648162!2d3.3469!3d6.4882!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b8c4e5b1d8e29%3A0x65bdaf002d2e142f!2s48%20Bode%20Thomas%20St%2C%20Surulere%20101283%2C%20Lagos%2C%20Nigeria!5e0!3m2!1sen!2sng!4v1696442912345!5m2!1sen!2sng"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          className="rounded-lg"
        ></iframe>
      </div>
      <Newsletter />
      <WhatsappButton />
    </main>
  );
};

export default Contact;
